var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"centered":"","color":"black","slider-color":"#99CC00"}},_vm._l((_vm.groupByOptions),function(group){return _c('v-tab',{key:group.value,staticClass:"tab-text",on:{"click":function($event){return _vm.$emit('change', group.value)}}},[_vm._v(" "+_vm._s(group.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }